import {
  Directive,
  ElementRef,
  AfterViewInit,
  Input,
  SimpleChanges,
} from "@angular/core";

@Directive({ selector: "[nisDraggable]" })
export class DraggableDirective implements AfterViewInit {
  @Input()
  draggable;

  @Input()
  draggableData;

  $el: any;

  constructor(el: ElementRef) {
    this.$el = $(el.nativeElement);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialize();
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initialize();
  }

  initialize() {
    (<any>this.$el).data("data", this.draggableData);
    (<any>this.$el).draggable(this.draggable);
  }
}
